import { makeStyles } from '@policygenius/mortar';

type Classes =
  | 'header'
  | 'logo'
  | 'nav'
  | 'chatIcon'
  | 'phoneIcon'
  | 'callText'
  | 'callLabel'
  | 'callNumber';

interface Options {
  isAccountHolder: boolean;
}

export default makeStyles<Options, Classes>(({ breakpoints, spacing, typography }) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '60px',
    background:
      'linear-gradient(81deg, rgba(211, 215, 245, 0.5) -62.89%, rgba(255, 244, 240, 0.5) 99.6%)',
    padding: [0, '3rem'],
    [`@media only screen and (max-width: ${breakpoints.medium - 1}px)`]: {
      paddingLeft: spacing('large'),
      paddingRight: ({ isAccountHolder }) => (isAccountHolder ? 0 : spacing('medium')),
    },
  },
  logo: {
    width: '147px',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,

    // accounts for some slight layout shift between this nav and the old DI nav
    // can be removed after migration is done
    marginTop: '-2px',
  },
  chatIcon: {
    marginRight: spacing('large'),
  },
  phoneIcon: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit',
    marginRight: spacing('large'),
  },

  callText: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: spacing('medium'),
    lineHeight: 1.2,
  },

  callLabel: {
    fontSize: '1rem',
    fontWeight: typography.fontWeight.bold,
    color: typography.fontColor.primary,
    fontFamily: typography.fontFamily.sansSerif,
  },

  callNumber: {
    fontSize: '1rem',
    fontWeight: typography.fontWeight.medium,
    color: typography.fontColor.primary,
    fontFamily: typography.fontFamily.sansSerif,
  },
}));
